import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, path = '' }) {
  const siteName = 'TeenHands';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} — Volunteer Opportunities & Side Gigs for Teens`;
  const desc = description || 'TeenHands connects teens ages 13–18 with local volunteer opportunities and paid side gigs. Build skills, earn money, and make a difference in your community.';
  const url = `https://teenhands.com${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
}
